import { render } from "./monitoring.vue?vue&type=template&id=4bf6f63c&scoped=true"
import script from "./monitoring.vue?vue&type=script&lang=js"
export * from "./monitoring.vue?vue&type=script&lang=js"

import "./monitoring.vue?vue&type=style&index=0&id=4bf6f63c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4bf6f63c"

export default script